module.exports = __webpack_public_path__ + "img/confirm.e21937ff.png";